export default {
  login: {
    login: '登入',
    loginSubtitle: '登入你的帐号',
    username: '帐号',
    password: '密码',
    forgetPassword: '忘记密码?'
  },
  forgetPassword: {
    forgetPassword: '忘记密码',
    forgetPasswordSubtitle: '输入你的用户名重设密码',
    username: '用户名称',
    backToLogin: '回去登入',
    success: '你的密码已被重设 新密码会送到你的注册电邮'
  }
}


// WEBPACK FOOTER //
// ./src/Auth/langs/zh_cn/index.js